.currency {
  font-size: 8px;
  text-transform: uppercase;
  margin-top: 2px;
}

.stampWrapper {
  display: flex;
  justify-content: center;
}

.flexWrapper {
  display: flex;
  gap: 2px;
  justify-content: end;
}

.priceWrapper {
  display: flex;
  justify-content: flex-end;
  flex-basis: 40%;
  gap: 4px;
  color: var(--text-default);

  &.isDisabled {
    color: var(--text-disabled);
  }
}

.circleStamp {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--stamp-color);
}

.squareStamp {
  width: 6px;
  height: 6px;
  background-color: var(--stamp-color);
}

.skeletonLoaderWrapper {
  display: flex;
  justify-content: flex-end;
}
